<!--
 * @Date: 2020-08-26 16:39:31
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-09-14 15:23:24
 * @FilePath: \pc-mall\src\components\CopyRight.vue
-->
<template>
  <div class="footer">
    <p>
      陕ICP备05007537号
      Copyright © 2012-2014 BMY.COM.CN All Rights Reserved
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.footer {
  font-family: "SimSun";
  height: 78px;
  bottom: 0;
  line-height: 78px;
  box-sizing: border-box;
  font-size: 14px;
  background-color: #cecece;
  text-align: center;
}
</style>
